import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TableCell, TableRow, Typography } from '@mui/material';
import SvgIconStyle from 'components/SvgIconStyle';
import { renderRowCreatedAt } from 'utils/renderTableCell';

export function TagsRow({ row, index }) {
  const navigate = useNavigate();
  const { createdAt, text, category, type, inputTags, status } = row;
  return (
    <>
      <TableRow key={index} hover>
        <TableCell align="left">
          <Typography>{index + 1}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{renderRowCreatedAt('fa-IR', createdAt)}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{text}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{category || 'تعریف نشده'}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{type === 'multiSelect' ? 'چند انتخابی' : 'تک انتخابی'}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{inputTags.length}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>تعریف نشده</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{status || 'تعریف نشده'}</Typography>
        </TableCell>
        <TableCell>
          <div onClick={() => navigate('/dashboard/recommendation/question/edit', { state: row })} aria-hidden>
            <SvgIconStyle src="/icons/send_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
          </div>
        </TableCell>
      </TableRow>
    </>
  );
}
